import { getFunctions, httpsCallable } from "firebase/functions";
import { mapFirebaseError } from "./errorMapper";
export class FirebasePhoneOTPRepository {
    functions = getFunctions();
    async sendOTP(phone, language) {
        try {
            const sendOTP = httpsCallable(this.functions, "sendOTP");
            await sendOTP({ phone, language });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async verifyOTP(phone, code) {
        try {
            const verifyOTP = httpsCallable(this.functions, "verifyOTP");
            const result = await verifyOTP({ phone, otp: code });
            const data = result.data;
            return { customToken: data.token, uid: data.uid };
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebasePhoneOTPRepository.js.map